"use client";
import HoverDataProvider from "@casino/client/components/GameCard/Hover/Context/HoverDataProvider";
import DarkThemeProvider from "@casino/legacy/client/shared/ThemeProviders/DarkThemeProvider";
import LightThemeProvider from "@casino/legacy/client/shared/ThemeProviders/LightThemeProvider";
import AppContext from "@casino/legacy/shared/context/AppContext";
import ToastContextProvider from "@casino/legacyUi/Toast/Context/ToastContextProvider";
import type { HoverData } from "@casino/server/helpers/getHoverData";
import RouterContextProvider from "./RouterContextProvider";

type Props = AppContextProps & {
  hoverData: HoverData;
};

const ClientPagesRouterAdapter: FC<Props> = ({
  children,
  hoverData,
  ...appContextProps
}) => {
  const ThemeProvider =
    (appContextProps.colorScheme ?? "dark") === "dark"
      ? DarkThemeProvider
      : LightThemeProvider;

  return (
    <RouterContextProvider>
      <AppContext.Provider value={appContextProps}>
        <ThemeProvider>
          <ToastContextProvider userAgentData={appContextProps.userAgentData}>
            <HoverDataProvider initial={hoverData}>
              {children}
            </HoverDataProvider>
          </ToastContextProvider>
        </ThemeProvider>
      </AppContext.Provider>
    </RouterContextProvider>
  );
};

export default ClientPagesRouterAdapter;
